import { any, bool, node, number, oneOfType, string } from 'prop-types';
import React, { Children } from 'react';

export default function SearchPageSidebarSection({ headingText, children, itemCount, skeletonMode }) {
    const childrenCount = !skeletonMode ? (itemCount || Children.count(children)) : itemCount;
    return (
        <div
            className={'search-sidebar--section'}
        >
            {headingText && (
                <span
                    className={'search-sidebar--heading'}
                    style={{ marginBottom: '6px' }}
                >
                    {headingText}
                </span>
            )}
            {skeletonMode === true && (
                <span
                    className={'search-sidebar--heading skeleton'}
                    style={{ marginBottom: '1.5em' }}
                />
            )}
            <div
                className={`search-sidebar--section-inner${skeletonMode === true ? ' skeleton' : ''}`}
            >
                {children}
                {skeletonMode === true && (
                    <>
                        {new Array(childrenCount).fill(0).map((_v, idx) => (<div
                            key={`${_v}_${idx}`}
                            className={'skeleton-item'}></div>))}
                    </>
                )}
            </div>
        </div>
    );
}

SearchPageSidebarSection.propTypes = {
    headingText: any,
    children: node,
    itemCount: oneOfType([number, string]),
    skeletonMode: bool,
};

SearchPageSidebarSection.defaultProps = {
    skeletonMode: false,
};